import { render, staticRenderFns } from "./OsmObjects.vue?vue&type=template&id=a4124be0"
import script from "./OsmObjects.vue?vue&type=script&lang=js"
export * from "./OsmObjects.vue?vue&type=script&lang=js"
import style0 from "./OsmObjects.vue?vue&type=style&index=0&id=a4124be0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports